<div class="main">
  <div class="section">
    <div class="header">
      {{'ACCEPT.accept' | translate}} | # {{parentData.order.order}}
      <i class="material-icons" (click)="closeAcceptModal();">
        clear
      </i>
    </div>
    <div class="bodySection">
      <div class="startToDest">
        <div class="left">
          <div class="orgName"> {{orgDetails.organizationName}}</div>
          <div class="orderNo">
            <label *ngIf="orgDetails.rate_type != 'weight' && orgDetails.rate_type !== 'pallet'">{{'ACCEPT.offeredPrice'
              | translate}} </label>
            <label
              *ngIf="orgDetails.rate_type == 'weight' && orgDetails.rate_type !== 'pallet'">{{'ACCEPT.ratePerWeight' |
              translate}} </label>
            <label *ngIf="orgDetails.rate_type == 'pallet'">{{'ACCEPT.ratePerPallet' | translate}} </label>

            {{currencySymbol}} {{(orgDetails.offeredPrice == 'N/A') ? orgDetails.offeredPrice : orgDetails.offeredPrice
            |numberFormat:orgDetails.offeredPrice}}
          </div>
        </div>
        <div class="right">
          <div class="allocated"><label>{{'ACCEPT.pickup' | translate}}: </label>{{parentData.order.pickDate}}</div>
          <div *ngIf="allocation_type =='vehicle'" class="vehicleType">{{orgDetails.vehicleType}}</div>
        </div>
        <!-- <div class="location">
            {{location.start}}
              <i class="material-icons">arrow_right_alt</i>
            {{location.destination}}
        </div> -->
      </div>
      <div class="tableSection">
        <table mat-table [dataSource]="acceptArr" class="table" style="width: 97%; margin-left: 10px;">
          <ng-container *ngIf="allocation_type =='vehicle'" matColumnDef="availableVehicles">
            <th mat-header-cell *matHeaderCellDef>{{'ACCEPT.availableVehicles' | translate}}</th>
            <td mat-cell *matCellDef="let element" style="font-size: 32px;"> {{availableNumber}} </td>
          </ng-container>
          <ng-container matColumnDef="allocated">
            <th mat-header-cell *matHeaderCellDef>{{'ACCEPT.allocated' | translate}}</th>
            <td mat-cell *matCellDef="let element" style="font-size: 32px;"> {{ parentData.to_be_accepted }} </td>
          </ng-container>
          <ng-container matColumnDef="accepted">
            <th mat-header-cell *matHeaderCellDef> {{'ACCEPT.accepted' | translate}} </th>
            <td mat-cell *matCellDef="let element">
              <div class="full">
                <div class="right">
                  <input type="number" [(ngModel)]="acceptNumber" autofocus />
                </div>
              </div>

            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
          <tr mat-row *matRowDef="let row; columns: columnsToDisplay;"></tr>
        </table>
      </div>
      <div class="submitButton">
        <div class="button" appDbclick (debounceClick)="accept(acceptNumber)">
          <span>{{'ACCEPT.submit' | translate}}</span>

        </div>
      </div>
      <div class="rejectButton" style="float: left; margin-left: 10px;">
        <div class="button" appDbclick (debounceClick)="accept(0, 'reject')">
          <span>{{'ACCEPT.rejectAll' | translate}}</span>

        </div>

      </div>
      <div class="acceptButton">
        <div class="button accept" appDbclick (debounceClick)="accept(parentData.to_be_accepted)">
          <span>{{'ACCEPT.acceptAll' | translate}}</span>

        </div>
      </div>
    </div>
  </div>
</div>